// import * as React from "react";
import Modal from "@mui/material/Modal";

export default function VuiModal({ isOpen = false, onClose = () => {}, children }) {
  return (
    <div>
      <Modal open={isOpen} onClose={onClose}>
        {children}
      </Modal>
    </div>
  );
}
